import { Badge } from "@/components/ui/badge";
import { titleCase } from "@/lib/utils";

// Order statuses: OPEN (in progress), SERVED, PAID, CANCELLED.
// Item statuses: PENDING, PREPARING, READY, SERVED.
const SUCCESS = new Set(["PAID", "READY"]);
const WARNING = new Set(["OPEN", "PREPARING"]);
const DESTRUCTIVE = new Set(["CANCELLED"]);
const NEUTRAL = new Set(["SERVED"]);

export function StatusBadge({ status }: { status: string | null | undefined }) {
  if (!status) return <Badge variant="outline">—</Badge>;
  const variant = SUCCESS.has(status)
    ? "success"
    : WARNING.has(status)
      ? "warning"
      : DESTRUCTIVE.has(status)
        ? "destructive"
        : NEUTRAL.has(status)
          ? "outline"
          : "secondary";
  return <Badge variant={variant}>{titleCase(status)}</Badge>;
}
